import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';

import { initSystems } from '@hooks/useSystems';

import { router } from './router';

import '@styles/main.scss';

const rootElement = document.getElementById('root');

// Fail loudly rather than rendering into nothing. If index.html and this
// file ever disagree, that is a build error, not a blank page to debug.
if (!rootElement) {
  throw new Error('Root element #root was not found in the document.');
}

/* Before React renders, deliberately: the glass mode decides whether
   surfaces mount with a refraction filter, and the GSAP plugins must be
   registered before the first page's reveal effects run. Mounting in one
   state and correcting afterwards would be a visible flash. */
initSystems();

createRoot(rootElement).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
